import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import ServiceGrid from "../components/ServiceGrid";

export default function Servizi() {
  return (
    <>
      <SEO
        title="I Nostri Servizi | Sisal Store Mestre, Padova, Sant'Angelo"
        description="Scommesse sportive, ippica, giochi, eventi sportivi in diretta, apertura conto gioco e assistenza: scopri tutti i servizi dei nostri Sisal Store."
      />
      <section data-testid="servizi-page" className="bg-slate-50 py-16 sm:py-24">
        <div className="container-x">
          <Reveal>
            <p className="overline-tag">I nostri servizi</p>
            <h1 className="mt-3 max-w-3xl font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Tutto quello che cerchi, in un unico posto
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-500 sm:text-lg">
              Sei categorie di servizi, un unico interlocutore vicino a casa tua. I servizi
              disponibili possono variare da sede a sede: controlla la pagina della tua sede.
            </p>
          </Reveal>
          <div className="mt-12">
            <ServiceGrid />
          </div>
          <Reveal delay={0.15}>
            <div className="mt-12 flex flex-col items-start gap-4 rounded-3xl border border-emerald-100 bg-emerald-50/70 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
              <p className="max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
                Vuoi sapere quali servizi sono disponibili nella sede più vicina a te?
              </p>
              <Link to="/#sedi" data-testid="servizi-find-store-btn" className="btn btn-primary btn-md shrink-0">
                <MapPin className="h-4 w-4" />
                TROVA LA SEDE
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
